import Card from "../Base/Card";
import {FiChevronDown, FiEye, FiEyeOff} from "react-icons/fi";
import React, {useState} from "react";
import SuccessModal from "../SuccessModal";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import ErrorViewer from "../ErrorViewer";
import LoadingSpinner from "../LoadingSpinner";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {ChangePassword} from "../../redux/selfService/selfServiceSlice";
import { logoutUser } from "../../redux/auth/authSlice";

const ChangePasswordComponent = ()=>{
    const dispatch = useAppDispatch();
    const { isLoading } = useAppSelector((state) => state?.selfService);
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    const toggleShowOldPassword = () => setShowOldPassword(!showOldPassword);
    const toggleShowPassword = () => setShowPassword(!showPassword);
    const toggleShowPassword2 = () => setShowPassword2(!showPassword2);
    const toggleShowSuccessModal = () => setShowSuccessModal(!showSuccessModal)

    // const validationSchema = Yup.object().shape({
    //     oldPassword: Yup.string().required("Please enter old password"),
    //     newPassword: Yup.string().required("Please enter new password"),
    //     confirmNewPassword: Yup.string()
    //         .required('Please retype your password.').oneOf([Yup.ref('newPassword')], 'Passwords must match'),
    // });


    

  const isPasswordComplex = (password) => {
    const passwordRegex = /^[A-Za-z0-9_@./*#&+-]{8,40}$/;

    return passwordRegex.test(password);
  };

  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required("Please enter old password"),
    newPassword: Yup.string()
      .required("Please enter new password")
      .test({
        name: 'is-complex',
        message: 'Password must contain minimum of 8 characters with letters, numbers, and special characters (_@./*#&+-)',
        test: (value) => isPasswordComplex(value),
      }),
    confirmNewPassword: Yup.string()
      .required('Please retype your password.')
      .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
  });

    const defaultValues = {
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: "",
    }

    const { handleSubmit, register, reset, formState: { errors },} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues
    });

    const onSubmit = (values: any)=>{
        dispatch(ChangePassword(values)).then(res => {
            if (res?.type === 'selfService/ChangePassword/fulfilled'  && res.payload?.statusCode === "00") {
                reset(defaultValues)
               dispatch( logoutUser());
            }
        })
    }

    return (
        <Card className="w-full">
            <SuccessModal
                showModal={showSuccessModal}
                onClose={toggleShowSuccessModal}
                note={"Your password has been changed successfully."}
            />

            <div className="mgmt">

            <div className="form__head mb-8">
                Manage your password
            </div>
            <div className="form__group">
                <label htmlFor="old-password" className="form__label">Old Password</label>
                <div className="form__input--group">
                    <input
                        id="old-password"
                        placeholder="Enter old password"
                        type={ showOldPassword ? 'text' : 'password'}
                        className="form__input append"
                        autoComplete="new-password"
                        {...register("oldPassword")}
                    />
                    <div className="append__input">
                        <button className="btn-text" onClick={toggleShowOldPassword}>
                            { !showOldPassword ?
                                <FiEye className="text-xl" />
                                : <FiEyeOff className="text-xl" />
                            }
                        </button>
                    </div>
                </div>
                {errors.oldPassword && (
                    <ErrorViewer message={errors.oldPassword.message as string}/>
                )}
            </div>
            <div className="form__group">
                <label htmlFor="new-password" className="form__label">New Password</label>
                <div className="form__input--group">
                    <input
                        placeholder="Enter new password"
                        id="new-password"
                        type={ showPassword ? 'text' : 'password'}
                        className="form__input append"
                        {...register("newPassword")}
                    />
                    <div className="append__input">
                        <button className="btn-text" onClick={toggleShowPassword}>
                            { !showPassword ?
                                <FiEye className="text-2xl" />
                                : <FiEyeOff className="text-2xl" />
                            }
                        </button>
                    </div>
                </div>
                {errors.newPassword && (
                    <ErrorViewer message={errors.newPassword.message as string}/>
                )}
            </div>
            <div className="form__group">
                <label htmlFor="confirm-new-password" className="form__label">Confirm New Password</label>
                <div className="form__input--group">
                    <input
                        placeholder="Enter new password"
                        id="confirm-new-password"
                        type={ showPassword2 ? 'text' : 'password'}
                        className="form__input append"
                        {...register("confirmNewPassword")}
                    />
                    <div className="append__input">
                        <button className="btn-text" onClick={toggleShowPassword2}>
                            { !showPassword2 ?
                                <FiEye className="text-2xl" />
                                : <FiEyeOff className="text-2xl" />
                            }
                        </button>

                    </div>
                </div>
                {errors.confirmNewPassword && (
                    <ErrorViewer message={errors.confirmNewPassword.message as string}/>
                )}
            </div>
            <div className="mt-4">
                <button className="btn btn-primary w-full" onClick={handleSubmit(onSubmit)}>
                    {isLoading ? <LoadingSpinner /> : "Confirm"}
                </button>
            </div>
            
            </div>
        </Card>
    )
}
export default ChangePasswordComponent;